import cn from 'clsx'
import { IMAGE_RESIZE_SPEC } from '@core/image'
import { buttonClassNames, ResponsiveImage } from '@ds/components'

import type { TMusehubBannerProps } from './MusehubBanner.types'
import styles from './MusehubBanner.module.css'

const COVER_SIZES = { large: '(max-width: 767px) 88px, 164px', small: '88px' }

export const MusehubBanner = ({
    cover,
    label,
    title,
    description,
    cta,
    href,
    offer,
    size = 'large',
    onClick,
}: TMusehubBannerProps) => (
    <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${label}: ${title}`}
        onClick={onClick}
        className={cn(styles.banner, styles[size])}
    >
        {offer ? (
            <span className={styles.offer}>
                <span className={styles.offerText}>{offer}</span>
            </span>
        ) : null}
        <div className={styles.cover}>
            <ResponsiveImage
                src={cover}
                alt={label}
                sizes={COVER_SIZES[size]}
                className={styles.coverImage}
                resize={IMAGE_RESIZE_SPEC}
            />
        </div>
        <div className={styles.head}>
            <p className={styles.label}>{label}</p>
            <p className={styles.title}>{title}</p>
        </div>
        <div className={styles.body}>
            <div className={styles.descriptionBox}>
                <p className={styles.description}>{description}</p>
            </div>
            <button
                type="button"
                className={cn(buttonClassNames({ variant: 'primary', size: 'small' }), styles.cta)}
            >
                {cta}
            </button>
        </div>
    </a>
)
